import React from 'react';
import styled from 'styled-components';
import { Border, Color, Grid, Type } from '../../../app/StyleGuide';
import { LikertAnswer, LikertScale } from '../models/assessment';
import { ChoiceIndicator } from './ChoiceIndicator';

const AnswerList = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Grid._2};
`;

const AnswerItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  gap: ${Grid._3};
  padding: ${Grid._3} ${Grid._4};
  border-radius: ${Border.radius};
  font-size: ${Type.Scale._2};
  color: ${props => (props.$isSelected ? Type.Color.dark : Type.Color.medium)};
  font-weight: ${props => (props.$isSelected ? Type.Weight.medium : Type.Weight.normal)};
  background: ${props => (props.$isSelected ? Color.Gray._10 : 'transparent')};
  border: 1px solid ${props => (props.$isSelected ? Color.Gray._30 : 'transparent')};
  line-height: ${Type.Leading.tall};
`;

type AnswerOption = {
  key: string;
  label: string;
  isSelected: boolean;
};

type AnswerResultProps = {
  questionID: string;
  options: AnswerOption[];
};

const AnswerResult = ({ questionID, options }: AnswerResultProps) => (
  <AnswerList>
    {options.map(option => (
      <AnswerItem key={`result-${questionID}-${option.key}`} $isSelected={option.isSelected}>
        <ChoiceIndicator $checked={option.isSelected} />
        {option.label}
      </AnswerItem>
    ))}
  </AnswerList>
);

type LikertAnswerResultProps = {
  questionID: string;
  answer?: LikertAnswer;
  scale: LikertScale;
};

export function LikertAnswerResult({ questionID, answer, scale }: LikertAnswerResultProps) {
  if (!answer) return null;

  const options = scale.options.map(o => ({
    key: String(o.score),
    label: o.label,
    isSelected: o.score === answer.score,
  }));

  return <AnswerResult questionID={questionID} options={options} />;
}
